import { CLEAR_QUOTES } from "./types";

export const clearQuotes = () => ({
    type: CLEAR_QUOTES
});
